export const formatVkLink = (fromId) => (fromId ? `https://vk.com/${fromId < 0 ? 'club' : 'id'}${Math.abs(fromId)}` : '');
export const formatDate = (timestamp) => (timestamp ? new Date(timestamp * 1000).toLocaleString('ru-RU') : 'Нет даты');

export const truncateText = (text, limit = 10) => {
    if (!text) return 'Нет текста';
    const words = text.split(' ').filter((word) => word.length > 0);
    return words.length > limit ? words.slice(0, limit).join(' ') + '...' : text;
  };

